import { Api, getPostParams, getDeleteParams } from "../../utils";
import urls from "../../config/urls";
import { } from "./types";

export function fetchRejectedBPApi(payload) {
  return Api.fetch(`${urls.businessPartner}/Rejected`, getPostParams(payload));
}
export function deleteBusinessPartnerApi(businessPartnerID) {
  return Api.fetch(
    `${urls.businessPartner}/${businessPartnerID}`,
    getDeleteParams()
  );
}
